{
    "components": {
        "buttons": {
            "default": {
                "add_to_cart": {
                    "label": "Ajouter au panier"
                },
                "back": {
                    "label": "Retour"
                },
                "cancel": {
                    "label": "Annuler"
                },
                "close": {
                    "label": "Fermer"
                },
                "confirm": {
                    "label": "Confirmer"
                },
                "delete": {
                    "label": "Supprimer"
                },
                "edit": {
                    "label": "Modifier"
                },
                "next": {
                    "label": "Suivant"
                },
                "previous": {
                    "label": "Précédent"
                },
                "proceed_configuration": {
                    "label": "Continuer"
                },
                "save": {
                    "label": "Enregistrer"
                },
                "start_ordering": {
                    "label": "Commencer à commander"
                },
                "upload_photo": {
                    "label": "Télécharger une photo"
                }
            },
            "previous_page": {
                "label": "Page précédente"
            },
            "close": {
                "label": "Fermer"
            }
        },
        "discount_blocks": {
            "code_copied": "Code copié !"
        },
        "dropdown": {
            "menu_button": {
                "label": "Menu"
            }
        },
        "footer": {
            "newsletter": {
                "title": "Ne manquez plus jamais une offre",
                "subtitle": "Inscrivez-vous à notre newsletter",
                "email_label": "Adresse e-mail",
                "submit_button": "Envoyer"
            }
        },
        "header": {
            "all_categories_line_1": "Voir toutes les",
            "all_categories_line_2": "catégories",
            "search_aria_label": "Rechercher",
            "search_close_aria_label": "Fermer la recherche",
            "search_placeholder": "Que recherchez-vous ?",
            "search_all_designs_title": "Tous les designs pour ‘{query}’",
            "search_all_designs_label": "designs",
            "search_suggestions_title": "Suggestions de recherche",
            "search_products_title": "Produits",
            "search_no_results_title": "Aucun design pour ‘{query}’",
            "search_no_results_hint": "Vérifiez l’orthographe ou essayez un mot plus large.",
            "search_scope_all_products": "Tous les produits",
            "search_scope_products": "Produit…",
            "search_all_designs_title_scoped": "Tous les designs pour ‘{query}’ dans {group}",
            "search_scope_reset": "Rechercher ‘{query}’ dans tous les produits",
            "search_popular_on_title": "Populaire chez {name}",
            "search_categories_title": "Catégories"
        },
        "layouts": {
            "login_status": {
                "cart": {
                    "label": "Panier"
                },
                "login": {
                    "label": "Se connecter"
                },
                "welcome": {
                    "label": "Bienvenue,"
                },
                "welcome_back": {
                    "label": "Bon retour"
                }
            },
            "mobile_menu_button": {
                "label": "Menu"
            },
            "mobile_menu_drawer": {
                "back_to_categories": "Retour à toutes les catégories",
                "close": "Fermer le menu",
                "default_title": "Menu",
                "view_all": "Voir tout {title}",
                "expand_submenu": "Développer le sous-menu"
            }
        },
        "select_menus": {
            "default": {
                "placeholder": "Sélectionner une option"
            }
        },
        "spinners": {
            "default": {
                "label": "Chargement..."
            }
        },
        "header_slider": {
            "timer": {
                "days": "j",
                "hours": "h",
                "minutes": "m",
                "seconds": "s"
            }
        },
        "modals": {
            "register": {
                "has_account": "Déjà un compte ?",
                "general_error": "L'inscription a échoué. Veuillez réessayer."
            },
            "login": {
                "title": "Se connecter"
            }
        },
        "wishlist": {
            "button": {
                "add_aria_label": "Ajouter à la liste de souhaits",
                "remove_aria_label": "Retirer de la liste de souhaits"
            },
            "header_button": {
                "aria_label": "Liste de souhaits"
            },
            "toast": {
                "removed": "Retiré de votre liste de souhaits",
                "undo": "Annuler"
            },
            "guest_added": {
                "title": "Liste de souhaits",
                "success": "Ajouté à votre liste de souhaits",
                "login_prompt": "{login} ou {register} pour conserver votre liste de souhaits sur tous vos appareils et la partager.",
                "login": "Connectez-vous",
                "register": "créez un compte",
                "continue_shopping": "Continuer mes achats",
                "view_wishlist": "Voir la liste de souhaits"
            }
        },
        "related_products": {
            "title": "Choisissez votre design",
            "show_all": "Voir tout",
            "show_less": "Voir moins",
            "section_title": "Découvrez plus de cette collection"
        },
        "same_kind_products": {
            "title": "Ceux-ci devraient aussi vous plaire"
        },
        "same_print_products": {
            "title": "Cette impression sur plus de produits"
        },
        "pdp_steps": {
            "step_label": "Étape {number}"
        },
        "pdp_review_videos": {
            "play_label": "Lire l'avis vidéo de {name}"
        },
        "video": {
            "play_label": "Lire la vidéo"
        },
        "slider": {
            "go_to_item": "Aller à l’élément {index} sur {total}"
        },
        "lightbox": {
            "counter": "{current} sur {total}"
        },
        "share": {
            "copy": "Copier le lien",
            "copied": "Lien copié",
            "more": "Plus",
            "sms": "Messages",
            "email": "E-mail"
        }
    },
    "general": {
        "delivery_options": {
            "day_after_tomorrow": {
                "label": "Commandez aujourd'hui, livré <b>après-demain</b> !"
            },
            "delivered_in_days": {
                "label": "Livré en <b>{days} jours</b>"
            },
            "delivered_in_business_days": {
                "label": "Commandé aujourd'hui, livré en {days} jour ouvrable ! | Commandé aujourd'hui, livré en {days} jours ouvrables !"
            },
            "today_delivery": {
                "label": "Commandez aujourd'hui, livré <b>aujourd'hui</b> !"
            },
            "tomorrow_delivery": {
                "label": "Commandez aujourd'hui, livré <b>demain</b> !"
            }
        },
        "password": {
            "confirmation": {
                "label": "Confirmer le mot de passe"
            },
            "confirmation_new": {
                "label": "Confirmer le nouveau mot de passe"
            },
            "current": {
                "label": "Mot de passe actuel"
            },
            "label": "Mot de passe",
            "mismatch": "Les mots de passe ne correspondent pas, veuillez vérifier les champs à nouveau.",
            "new": {
                "label": "Nouveau mot de passe"
            },
            "requirements": "Utilisez 3 types de caractères différents. Caractères possibles : lettres minuscules, majuscules, chiffres et caractères spéciaux."
        },
        "price_tables": {
            "entries": {
                "amount_label": "1 pièce | {count} pièces",
                "all_sizes": "Toutes les tailles"
            },
            "title": {
                "amount": "Quantité",
                "size": "Taille"
            }
        },
        "prices": {
            "excl_discount": {
                "label": "Prix hors remise"
            },
            "for": {
                "label": "Pour"
            },
            "from": {
                "label": "De"
            },
            "starting_from": {
                "label": "À partir de"
            },
            "title": "Prix",
            "total": {
                "label": "Total"
            }
        },
        "product_description": {
            "title": "Description du produit"
        },
        "question_and_answers": {
            "no_data": {
                "primary_text": "Aucune question et réponse trouvée."
            },
            "title": "Questions et réponses",
            "subtitle": "Les questions les plus fréquentes de nos clients."
        },
        "reviews": {
            "buyer": "Acheteur",
            "customer_images": "Images des clients",
            "view_more_images": "Voir plus",
            "filter_all_stars": "Tout afficher",
            "filter_label": "Filtre",
            "filter_stars": "1 étoile | {count} étoiles",
            "highest_rated_title": "Avis clients",
            "no_reviews_title": "Pas encore d'avis écrits",
            "no_reviews_description": "Il y a 1 note de {rating} étoiles. | Il y a {votes} notes avec une moyenne de {rating} étoiles.",
            "image_alt": "Image de l'avis",
            "no_results_for_filter": "Aucun avis pour ce filtre.",
            "read_full_review": "Lire l'avis complet",
            "review_amount": "{count} avis | {count} avis",
            "review_count": "{votes} évaluations dont {reviewCount} rédigées",
            "show_all_reviews": "Afficher les {count} avis clients",
            "show_less": "Afficher moins",
            "show_original": "Ceci est une traduction, afficher l'original",
            "show_star_reviews": "Afficher les avis {score} étoiles",
            "show_translation": "Afficher la traduction",
            "title": "Avis clients",
            "about": "Sur :",
            "read_more": "Lire la suite",
            "show_all": "Voir les {count}",
            "votes_count": "1 avis | {count} avis"
        },
        "shipping_options": {
            "title": "Options de livraison"
        },
        "show_more_products": "Afficher plus de produits",
        "stock": {
            "available": "Disponible immédiatement en stock"
        },
        "checkout": {
            "title": "Commande"
        },
        "filter_amount_products": "Filtrer {count} produits",
        "pickup_points": {
            "pickup_location": {
                "confirmed": "Point de retrait sélectionné!",
                "select": "Récupérez ici"
            }
        },
        "price_table": {
            "filters": {
                "show_less": "Afficher moins de tailles",
                "show_more": "Afficher plus de tailles"
            }
        },
        "show_less_collections": "Afficher moins de collections",
        "show_more_collections": "Afficher plus de collections",
        "show_more": "Afficher plus",
        "show_less": "Afficher moins",
        "product_details": "Informations produit"
    },
    "pages": {
        "cart_page": {
            "add_product": "Ajouter un autre produit",
            "coupon_applied": "Code de réduction appliqué.",
            "coupon_apply_failed": "Le code de réduction n'a pas pu être appliqué.",
            "free_shipping_remaining": "Plus que {amount} pour la {free}",
            "free_shipping_goal": "livraison gratuite",
            "free_shipping_exception": "Hors colis XXL",
            "no_items_proceed_shopping_link": "ici",
            "overview_title": "Aperçu",
            "pages_count": "{count} pages",
            "quantity_update_failed": "La quantité ne peut pas être mise à jour.",
            "remove_modal": {
                "cancel": "Annuler",
                "confirm": "Voulez-vous vraiment retirer ce produit de votre panier ?",
                "set_confirm": "Si vous supprimez ce produit, la remise de set ne s'appliquera plus aux autres produits. Voulez-vous vraiment le supprimer ?",
                "title": "Supprimer le produit",
                "yes": "Oui, supprimer"
            },
            "cart_item": {
                "delete": "Supprimer",
                "edit": "Modifier",
                "edit_failed": "Le produit n'a pas pu être ouvert pour modification. Veuillez réessayer.",
                "quantity": {
                    "label": "Quantité"
                },
                "set_count": "{count} produit | {count} produits",
                "show_details": "Afficher les détails"
            },
            "messages": {
                "success": {
                    "deleted": "Le produit a été retiré de votre panier."
                }
            },
            "no_items": "Vous n’avez aucun produit dans votre panier.",
            "overview": {
                "coupon_code": {
                    "button": {
                        "label": "Appliquer"
                    },
                    "cancel": "Annuler",
                    "input": {
                        "placeholder": "Entrez votre code promo"
                    },
                    "title": "Entrez un code promo"
                },
                "coupon_code_display": "Code promo ({code})",
                "coupon_codes_display": "codes de réduction",
                "discount_display": "Remise",
                "item_count": "1 article | {count} articles",
                "prices": {
                    "discount": "Vous économisez",
                    "grand_total": "Total",
                    "shipping": "Livraison",
                    "subtotal": "Sous-total",
                    "tax": "TVA",
                    "tax_included": "dont {amount} de TVA",
                    "total_incl_tax": "Sous-total (TVA incluse)"
                }
            },
            "proceed_to_checkout": "Passer à la caisse",
            "title": "Panier",
            "no_items_proceed_shopping": "Cliquez {link} pour continuer vos achats.",
            "free_shipping": "Livraison gratuite",
            "free_shipping_reached": "{free} pour votre commande",
            "checkout_hint": "Ensuite : choisir l'adresse et le moment de livraison"
        },
        "category": {
            "filters_title": "Filtrer",
            "clear_all": "Tout effacer",
            "selected_count": "{count} sélectionné(s)",
            "selected_filters": "Filtres sélectionnés",
            "hierarchy_all": "Tout {label}",
            "close_filters": "Fermer les filtres",
            "no_filter_options_available": "Aucune option de filtrage disponible",
            "no_image": "Pas d'image",
            "open_grid_view": "Ouvrir la vue grille",
            "open_list_view": "Ouvrir la vue liste",
            "open_two_column_view": "Ouvrir la vue sur 2 colonnes",
            "products": {
                "label": "produits",
                "prices": {
                    "recommended_price": "autre"
                }
            },
            "remove_filter": "Supprimer le filtre {filter} : {value}",
            "show_results": "Afficher les résultats",
            "show_results_with_count": "Afficher {count} résultats",
            "clear_filters": "Supprimer tous les filtres",
            "filter": "Filtre",
            "show_less_filters": "Afficher moins",
            "show_more_filters": "Afficher plus",
            "faqs": {
                "title": "Questions fréquentes"
            },
            "header": {
                "header_description": {
                    "show_more": "Afficher plus",
                    "show_less": "Afficher moins"
                }
            },
            "filter_explanation": "Plus d'informations sur ce filtre"
        },
        "collection": {
            "delivery_options": {
                "pickup_point": "Point de retrait (choix durable)"
            }
        },
        "customers": {
            "dashboard": {
                "account_information": {
                    "form": {
                        "assistance_allowed_label": "Autoriser l'assistance à distance lors des achats",
                        "assistance_allowed_tooltip": "Cela permet au personnel de voir votre écran et d'effectuer des actions en votre nom pour mieux vous aider lors de vos achats.",
                        "email_label": "Adresse e-mail",
                        "first_name_label": "Prénom",
                        "last_name_label": "Nom",
                        "legend": "Informations du compte",
                        "submit_button": "Enregistrer"
                    },
                    "index": {
                        "intro": "Mes coordonnées et paramètres de compte.",
                        "title": "Informations du compte"
                    }
                },
                "address": {
                    "billing_title": "Adresse de facturation par défaut",
                    "description": "Adresse de facturation et de livraison par défaut actuelle.",
                    "legend": "Carnet d'adresses",
                    "manage_link": "Gérer les adresses",
                    "shipping_title": "Adresse de livraison par défaut"
                },
                "addresses": {
                    "create": {
                        "intro": "Ajoutez une nouvelle adresse au carnet d'adresses.",
                        "title": "Nouvelle adresse"
                    },
                    "default_cards": {
                        "empty_state": "Aucune adresse par défaut définie."
                    },
                    "edit": {
                        "intro": "Modifiez une adresse existante du carnet d'adresses.",
                        "title": "Modifier l'adresse"
                    },
                    "form": {
                        "address_legend": "Adresse",
                        "city_label": "Ville",
                        "company_label": "Entreprise",
                        "contact_legend": "Coordonnées",
                        "countries": {
                            "AT": "Autriche",
                            "BE": "Belgique",
                            "DE": "Allemagne",
                            "FR": "France",
                            "LU": "Luxembourg",
                            "NL": "Pays-Bas"
                        },
                        "country_label": "Pays",
                        "default_billing_label": "Utiliser comme adresse de facturation par défaut",
                        "default_shipping_label": "Utiliser comme adresse de livraison par défaut",
                        "first_name_label": "Prénom",
                        "last_name_label": "Nom",
                        "postcode_label": "Code postal",
                        "region_label": "État/Province",
                        "street1_label": "Adresse",
                        "street2_label": "Ligne d'adresse 2",
                        "submit_create_button": "Ajouter l'adresse",
                        "submit_edit_button": "Enregistrer l'adresse",
                        "telephone_label": "Numéro de téléphone"
                    },
                    "index": {
                        "add_address_button": "Ajouter une adresse",
                        "billing_action_text": "Modifier l'adresse de facturation",
                        "billing_title": "Adresse de facturation par défaut",
                        "delete_modal_cancel_button": "Annuler",
                        "delete_modal_confirm_button": "Supprimer",
                        "delete_modal_description": "Êtes-vous sûr de vouloir supprimer cette adresse ?",
                        "delete_modal_title": "Supprimer l'adresse",
                        "intro": "Mes adresses et informations supplémentaires.",
                        "shipping_action_text": "Modifier l'adresse de livraison",
                        "shipping_title": "Adresse de livraison par défaut",
                        "title": "Carnet d'adresses"
                    },
                    "list": {
                        "address_column": "Adresse",
                        "city_column": "Ville",
                        "company_column": "Entreprise",
                        "country_column": "Pays",
                        "delete_label": "Supprimer",
                        "edit_title": "Modifier",
                        "empty_state": "Aucune autre adresse n'est encore définie.",
                        "legend": "Autres adresses",
                        "name_column": "Nom"
                    }
                },
                "empty_address_state": "Aucune adresse n'a encore été définie.",
                "intro": "Bienvenue {firstName} ! Vous trouverez ci-dessous toutes vos informations et vos commandes récentes.",
                "navigation": {
                    "account_information": "Informations du compte",
                    "address_book": "Carnet d'adresses",
                    "dashboard": "Tableau de bord",
                    "logout": "Se déconnecter",
                    "orders": "Mes commandes",
                    "projects": "Mes livres photo",
                    "security": "Sécurité",
                    "title": "Mon compte",
                    "wishlist": "Liste de souhaits"
                },
                "order_history": {
                    "detail": {
                        "header": {
                            "date_label": "Date"
                        },
                        "index": {
                            "back_button": "Retour au récapitulatif des commandes",
                            "intro": "Aperçu détaillé d'une commande.",
                            "title": "Commande #{number}"
                        },
                        "info": {
                            "billing_address_title": "Adresse de facturation",
                            "payment_method_title": "Méthode de paiement",
                            "shipping_address_title": "Adresse de livraison",
                            "shipping_method_title": "Méthode d'expédition"
                        },
                        "items": {
                            "article_number_label": "Réf.",
                            "legend": "Articles commandés",
                            "price_column": "Prix",
                            "product_name_column": "Nom du produit",
                            "quantity_column": "Quantité",
                            "subtotal_column": "Sous-total"
                        },
                        "totals": {
                            "discount": "Réduction",
                            "grand_total": "Total (TVA incl.)",
                            "grand_total_excluding_tax": "Total (TVA excl.)",
                            "shipping": "Expédition et traitement",
                            "subtotal": "Sous-total",
                            "tax": "TVA"
                        }
                    },
                    "index": {
                        "intro": "Aperçu de mes commandes passées.",
                        "legend": "Mes commandes",
                        "order_count": "{count} commande | {count} commandes",
                        "title": "Mes commandes"
                    },
                    "table": {
                        "date_column": "Date",
                        "empty_state": "Vous n'avez pas encore passé de commandes.",
                        "order_number_column": "N° de commande",
                        "status_column": "Statut",
                        "total_column": "Total",
                        "tracking_column": "Suivi de commande",
                        "view_label": "Voir"
                    }
                },
                "orders": {
                    "date_column": "Date",
                    "empty_state": "Vous n'avez pas encore passé de commandes.",
                    "legend": "Commandes récentes",
                    "order_number_column": "N° de commande",
                    "shipping_to_column": "Expédier à",
                    "status_column": "Statut",
                    "total_column": "Total",
                    "view_all_link": "Voir tout",
                    "view_link": "Voir"
                },
                "profile": {
                    "create": {
                        "intro": "Ajoutez une nouvelle adresse au carnet d'adresses.",
                        "title": "Nouvelle adresse"
                    },
                    "edit": {
                        "intro": "Modifiez une adresse existante du carnet d'adresses.",
                        "title": "Modifier l'adresse"
                    },
                    "edit_link": "Modifier les informations de votre compte",
                    "form": {
                        "address_legend": "Adresse",
                        "city_label": "Ville",
                        "company_label": "Entreprise",
                        "contact_legend": "Coordonnées",
                        "country_label": "Pays",
                        "default_billing_label": "Utiliser comme adresse de facturation par défaut",
                        "default_shipping_label": "Utiliser comme adresse de livraison par défaut",
                        "first_name_label": "Prénom",
                        "last_name_label": "Nom",
                        "postcode_label": "Code postal",
                        "region_label": "État/Province",
                        "street1_label": "Adresse",
                        "street2_label": "Ligne d'adresse 2",
                        "submit_create_button": "Ajouter l'adresse",
                        "submit_edit_button": "Enregistrer l'adresse",
                        "telephone_label": "Numéro de téléphone"
                    },
                    "legend": "Coordonnées",
                    "list": {
                        "address_column": "Adresse",
                        "city_column": "Ville",
                        "company_column": "Entreprise",
                        "country_column": "Pays",
                        "delete_label": "Supprimer",
                        "edit_title": "Modifier",
                        "empty_state": "Aucune autre adresse n'est encore définie.",
                        "legend": "Autres adresses",
                        "name_column": "Nom"
                    }
                },
                "projects": {
                    "index": {
                        "intro": "Mes projets enregistrés et mes livres photo.",
                        "legend": "Mes livres photo",
                        "title": "Mes livres photo"
                    },
                    "list": {
                        "actions_column": "Actions",
                        "empty_state": "Vous n'avez pas encore enregistré de livres photo.",
                        "fallback_text": "Aperçu du livre photo",
                        "preview_alt": "Aperçu",
                        "preview_link": "Aperçu",
                        "product_column": "Produit",
                        "project_link": "Aller au projet",
                        "updated_at_column": "Dernière mise à jour"
                    }
                },
                "security": {
                    "form": {
                        "legend": "Changer le mot de passe",
                        "submit": "Enregistrer le mot de passe"
                    },
                    "index": {
                        "intro": "Mettez à jour le mot de passe de votre compte ici.",
                        "title": "Sécurité"
                    }
                },
                "title": "Mon compte",
                "wishlist": {
                    "index": {
                        "empty_state": "Votre liste de souhaits est vide.",
                        "intro": "Produits que vous avez enregistrés.",
                        "legend": "Ma liste de souhaits",
                        "title": "Liste de souhaits",
                        "guest_notice": "Enregistré sur cet appareil · {login} pour voir vos articles partout",
                        "guest_notice_login": "Connectez-vous"
                    },
                    "share": {
                        "button": "Partager",
                        "title": "Partagez votre liste de souhaits avec d'autres",
                        "description": "Toute personne disposant de ce lien peut voir votre liste de souhaits."
                    },
                    "shared": {
                        "title": "Liste de souhaits partagée",
                        "intro": "Ces produits ont été partagés avec vous."
                    }
                },
                "intro_no_name": "Bienvenue ! Vous trouverez ci-dessous toutes vos informations et vos commandes récentes."
            },
            "login": {
                "index": {
                    "create_account": "Créer un compte",
                    "description": "Si vous avez un compte, connectez-vous avec votre adresse e-mail.",
                    "email_label": "Adresse e-mail",
                    "email_placeholder": "nom{'@'}exemple.fr",
                    "forgot_password": "Mot de passe oublié ?",
                    "intro": "Connectez-vous ou créez un compte pour accéder à votre tableau de bord.",
                    "legend": "Se connecter",
                    "new_customers_description": "La création d'un compte offre de nombreux avantages : une validation de commande plus rapide, la sauvegarde de plusieurs adresses, le suivi des commandes et bien plus encore.",
                    "new_customers_legend": "Nouveaux clients",
                    "password_label": "Mot de passe",
                    "password_placeholder": "Entrez votre mot de passe",
                    "submit": "Se connecter",
                    "title": "Se connecter",
                    "sso_facebook": "Continuer avec Facebook",
                    "sso_google": "Continuer avec Google",
                    "sso_separator": "Ou"
                }
            },
            "passwords": {
                "forgot": {
                    "index": {
                        "back_button": "Retour à la connexion",
                        "description": "Si un compte existe avec l'adresse e-mail indiquée, vous recevrez un e-mail.",
                        "email_label": "Adresse e-mail",
                        "email_placeholder": "nom{'@'}exemple.fr",
                        "intro": "Entrez votre adresse e-mail ci-dessous pour recevoir un lien de réinitialisation de mot de passe.",
                        "submit_button": "Envoyer",
                        "title": "Mot de passe oublié ?"
                    }
                },
                "reset": {
                    "index": {
                        "intro": "Choisissez un nouveau mot de passe pour votre compte ci-dessous.",
                        "submit": "Définir un nouveau mot de passe",
                        "title": "Définir un nouveau mot de passe"
                    }
                }
            },
            "register": {
                "credentials": {
                    "email_label": "Adresse e-mail",
                    "legend": "Identifiants de connexion",
                    "privacy_link": "Politique de confidentialité",
                    "privacy_prefix": "J'accepte la"
                },
                "index": {
                    "back_button": "Retour à la connexion",
                    "intro": "Créez un nouveau compte pour gérer vos commandes, adresses et projets.",
                    "submit_button": "Créer un compte",
                    "title": "Créer un nouveau compte"
                },
                "profile": {
                    "first_name_label": "Prénom",
                    "last_name_label": "Nom",
                    "legend": "Informations personnelles",
                    "subscribe_label": "S'abonner à la newsletter"
                }
            }
        },
        "errors": {
            "back_to_home": "Retour à l’accueil",
            "404": {
                "heading": "Page introuvable.",
                "description": "Nous n'avons pas pu trouver la page que vous recherchez. Le lien a peut-être expiré ou la page a été déplacée."
            },
            "500": {
                "heading": "Une erreur est survenue.",
                "description": "Une erreur inattendue s'est produite de notre côté. Veuillez réessayer plus tard."
            },
            "403": {
                "heading": "Accès refusé.",
                "description": "Vous n'avez pas l'autorisation d'accéder à cette page."
            },
            "503": {
                "heading": "Temporairement indisponible.",
                "description": "Le site est temporairement indisponible. Veuillez réessayer plus tard."
            },
            "generic": {
                "heading": "Une erreur est survenue.",
                "description": "Une erreur inattendue s'est produite. Veuillez réessayer plus tard."
            }
        },
        "product_detail_page": {
            "share": {
                "label": "Partager cette page",
                "title": "Partagez ce produit avec d'autres"
            },
            "product_info": {
                "benefits": {
                    "title": "Les avantages de {storeName}",
                    "payment_methods_label": "payez entre autres avec"
                },
                "klarna": {
                    "loading": {
                        "label": "Klarna est en cours de chargement..."
                    }
                },
                "modals": {
                    "product_options_modal": {
                        "overview": {
                            "title": "Aperçu"
                        },
                        "title": "Options du produit"
                    }
                },
                "product_button": {
                    "add_to_cart": {
                        "error": "Une erreur est survenue lors de l'ajout au panier.",
                        "loading": {
                            "description": "Vous serez redirigé automatiquement.",
                            "label": "Ajout au panier..."
                        },
                        "set_error": "Une erreur est survenue lors de l'ajout du set. Certaines parties sont peut-être déjà dans votre panier : vérifiez-le avant de réessayer."
                    },
                    "book_login_modal": {
                        "continue_without_login": "Continuer sans se connecter",
                        "continue_without_login_warning": "Si vous continuez sans vous connecter, vos photos ne seront pas sauvegardées. Vous ne pourrez pas modifier ou finaliser votre produit ultérieurement.",
                        "description": "Connectez-vous pour sauvegarder votre progression et continuer votre projet plus tard.",
                        "email_label": "Adresse e-mail",
                        "email_placeholder": "nom{'@'}exemple.fr",
                        "forgot_password": "Mot de passe oublié ?",
                        "general_error": "Connexion échouée. Vérifiez vos informations et réessayez.",
                        "no_account": "Pas encore de compte ?",
                        "password_label": "Mot de passe",
                        "password_placeholder": "Entrez votre mot de passe",
                        "separator": "Ou",
                        "submit": "Se connecter",
                        "title": "Connexion"
                    },
                    "new_project_modal": {
                        "description": "Donnez un titre à votre livre photo pour le retrouver facilement. Vous pourrez le modifier plus tard.",
                        "submit": "Commencer à créer",
                        "title": "Nommez votre projet",
                        "title_hint": "{count} / 150",
                        "title_label": "Titre du projet",
                        "title_placeholder": "Ex. Vacances {year}, Album de famille..."
                    },
                    "recent_projects_modal": {
                        "description": "Reprenez un projet de livre photo existant ou démarrez un nouveau projet.",
                        "empty_state": "Vous n’avez pas encore de projets de livre photo récents.",
                        "error": "Une erreur est survenue lors du chargement de vos projets.",
                        "loading": "Chargement de vos projets récents...",
                        "next_page": "Suivant",
                        "open_error": "Le projet n’a pas pu être ouvert. Réessayez.",
                        "open_project": "Ouvrir le projet",
                        "opening": "Ouverture...",
                        "pagination": "Page {page} sur {total}",
                        "previous_page": "Précédent",
                        "retry": "Réessayer",
                        "sheet_count": "{count} pages",
                        "start_new_project": "Démarrer un nouveau projet",
                        "title": "Projets récents",
                        "updated_at": "Dernière modification : {date}"
                    },
                    "start_ordering": {
                        "loading": {
                            "description": "Nous préparons le designer pour vous.",
                            "label": "Votre produit est en cours de préparation..."
                        }
                    },
                    "start_over": {
                        "confirm_modal": {
                            "cancel": "Annuler",
                            "confirm": "Oui, recommencer",
                            "description": "Votre photo et vos paramètres actuels seront supprimés. Cette action est irréversible.",
                            "title": "Voulez-vous vraiment recommencer ?"
                        },
                        "label": "Ou recommencer, choisissez une nouvelle photo"
                    },
                    "upload": {
                        "errors": {
                            "file_too_large": "Cette photo est trop volumineuse. Veuillez importer une image de 100 Mo maximum.",
                            "generic": "Une erreur est survenue pendant l'envoi. Veuillez réessayer.",
                            "invalid_file_type": "Ce type de fichier n'est pas pris en charge. Veuillez importer une image JPG, PNG ou WebP.",
                            "retry_cta": "Réessayer",
                            "title": "Échec de l'envoi"
                        },
                        "leave_modal": {
                            "cancel": "Rester ici",
                            "confirm": "Arrêter l'envoi",
                            "description": "Votre photo est encore en cours d'envoi. Si vous quittez la page maintenant, votre progression sera perdue.",
                            "title": "Êtes-vous sûr de vouloir quitter ?"
                        },
                        "offline": {
                            "description": "Vous êtes hors ligne. Nous reprendrons dès que votre connexion sera rétablie.",
                            "title": "Pas de connexion"
                        },
                        "redirecting": {
                            "description": "Vous êtes redirigé.",
                            "label": "Téléchargement terminé !"
                        },
                        "uploading": {
                            "description": "Vous êtes automatiquement redirigé.",
                            "label": "Votre photo est en cours de traitement..."
                        }
                    },
                    "update_cart": {
                        "loading": {
                            "description": "Vous serez automatiquement redirigé vers votre panier.",
                            "label": "Votre produit est en cours de mise à jour."
                        }
                    },
                    "force_size_selection_message": "Veuillez d'abord sélectionner une taille pour continuer.",
                    "force_size_selection_tooltip": "Vous devez encore sélectionner une taille"
                },
                "product_filters": {
                    "choose_option": "Choisissez une option",
                    "make_your_choice": "Faites votre choix"
                },
                "product_set": {
                    "available_sizes_label": "Choisissez vos formats",
                    "discount_label": "Remise sur l'ensemble",
                    "position_label": "Image {number}",
                    "save_label": "Enregistrer",
                    "standard_sizes_note": "Les images sont basées sur des formats standards"
                },
                "switch_options": {
                    "with_name": "Avec prénom",
                    "without_name": "Sans prénom"
                }
            },
            "user_text": {
                "error": {
                    "empty": "Aucun texte saisi"
                },
                "label": "Texte personnel",
                "placeholder": "Saisissez votre texte..."
            },
            "price": {
                "from_abbreviation": "dès",
                "instead_of": "au lieu de"
            },
            "after_upload_text": "Ensuite : choisissez un format et consultez les prix.",
            "timer": {
                "label": "{days} jours et {hours}:{minutes}:{seconds}",
                "last_day_label": "Il ne reste que {hours} heures et {minutes}:{seconds}",
                "one_day_label": "{days} jour et {hours}:{minutes}:{seconds}"
            },
            "ai_upload": {
                "history": {
                    "loading_previous": "Chargement de votre version précédente",
                    "loading_latest": "Chargement de votre dernière version"
                },
                "auth": {
                    "email": {
                        "continue": "Continuer",
                        "context": "Saisissez votre adresse e-mail pour envoyer votre propre photo et la générer avec l'IA.",
                        "error": "Une erreur est survenue. Veuillez réessayer.",
                        "placeholder": "Votre adresse e-mail",
                        "title": "Continuer"
                    },
                    "login": {
                        "context": "Un compte existe déjà pour {email}. Connectez-vous pour continuer.",
                        "forgot_password": "Mot de passe oublié ?",
                        "general_error": "Connexion échouée. Vérifiez vos informations et réessayez.",
                        "password_placeholder": "Entrez votre mot de passe",
                        "submit": "Se connecter",
                        "title": "Connexion"
                    },
                    "otp": {
                        "general_error": "Une erreur est survenue. Veuillez réessayer.",
                        "intro": "Nous avons envoyé un code de vérification à {email}.",
                        "resend": "Vous n'avez pas reçu de code ? Renvoyer",
                        "resend_sent": "Nous vous avons envoyé un nouveau code.",
                        "submit": "Confirmer et choisir une photo",
                        "title": "Confirmez votre e-mail",
                        "submit_continue": "Confirmer"
                    },
                    "success": {
                        "title": "Connexion réussie !",
                        "cta": "Sélectionnez votre photo"
                    }
                },
                "ai_generated_badge": "Généré par IA",
                "view_full_screen": "Voir la photo en plein écran",
                "button": {
                    "label": "Commencer ma commande",
                    "choose_photo": "Choisissez votre photo",
                    "try_again": "Réessayer",
                    "offline": "Vous êtes hors ligne. Le téléchargement reprendra automatiquement dès que la connexion sera rétablie.",
                    "slow_connection": "Votre connexion est lente. Le chargement peut prendre un peu plus de temps.",
                    "add_text": "Ajouter un nom/texte",
                    "edit_text": "Modifier le nom/texte",
                    "errors": {
                        "invalid_file_type": "Ce type de fichier n'est pas pris en charge. Téléchargez une photo au format JPG, PNG ou WEBP.",
                        "file_too_small": "Ce fichier est trop petit. Choisissez une autre photo.",
                        "file_too_large": "Ce fichier est trop volumineux. Téléchargez une photo de 100 Mo maximum."
                    }
                },
                "progress": {
                    "retry": "Réessayer",
                    "retry_different_photo": "Télécharger une autre photo",
                    "beauty_shots_failed": "Malheureusement, nous n'avons pas pu créer tes aperçus produit. Veuillez réessayer.",
                    "image_failed": "Cette image de produit n'a pas pu être créée.",
                    "overtime": "Cela prend un peu plus de temps que prévu. Nous continuons, veuillez encore patienter.",
                    "shot_pending": "Cette photo produit est encore en cours de création. Vous pouvez déjà voir les autres.",
                    "creating_previews": "Nous créons maintenant les aperçus de votre produit...",
                    "title": "Votre image est en cours de création",
                    "subtitle": "En moyenne 60 à 90 secondes. Merci de votre patience.",
                    "baking_title": "Nous créons de nouvelles images produit pour vous",
                    "bake_progress_title": "Chargement des nouvelles images produit",
                    "bake_progress_subtitle": "De nouvelles images produit sont créées à partir de votre prénom.",
                    "preparing_photo_error": "Nous n'avons pas pu préparer ta photo produit. Veuillez réessayer.",
                    "preparing_photo_and_cart_title": "Nous ajoutons ton produit au panier",
                    "preparing_photo_and_cart_description": "Pendant ce temps, nous finalisons ta photo produit personnalisée.",
                    "beauty_shots_count": "{completed} sur {total}",
                    "steps": {
                        "analyzing": "Analyse de la photo",
                        "recognizing": "Reconnaissance du visage",
                        "styling": "Application du style",
                        "finalizing": "Finalisation du design",
                        "creating_images": "Création des images",
                        "uploading": "Traitement de votre photo",
                        "generating": "Création de votre image",
                        "processing": "Image en cours de finition",
                        "processing_plural": "Images en cours de finition",
                        "previews": "Création des images produit",
                        "preview_single": "Création de votre image produit",
                        "preview_plural": "Création de vos images produit",
                        "uploading_busy": "Cela prend un peu plus de temps que prévu...",
                        "analyzing_busy": "Analyse en cours...",
                        "generating_busy": "Création de votre image...",
                        "generating_busy_plural": "Création de vos images...",
                        "processing_busy": "Dernières retouches...",
                        "previews_busy": "Vos images produit sont en cours de création, encore un moment...",
                        "baking_text": "Intégration du texte...",
                        "baking_style": "Application du texte et du style",
                        "baking_text_subtitle": "Votre texte est appliqué sur l'image.",
                        "baking_photo": "Mise à jour de l'image produit",
                        "addition_activating": "Chargement du style {label}",
                        "addition_transforming": "Transformation de l'image",
                        "addition_transforming_subtitle": "Nous transformons votre image",
                        "addition_generating": "Génération de {label}",
                        "addition_finalizing": "Finalisation des détails",
                        "uploading_subtitle": "Nous préparons ta photo pour l'IA",
                        "analyzing_subtitle": "Nous regardons ce qu'il y a dessus",
                        "generating_subtitle": "L'IA crée ton image personnalisée",
                        "generating_subtitle_plural": "L'IA crée tes images personnalisées",
                        "processing_subtitle": "Nous ajoutons les dernières retouches",
                        "addition_activating_subtitle": "Nous chargeons le style choisi",
                        "uploading_done": "Photo traitée",
                        "analyzing_done": "Photo analysée",
                        "generating_done": "Image créée",
                        "generating_done_plural": "Images créées",
                        "processing_done": "Détails terminés",
                        "addition_activating_done": "Style chargé",
                        "addition_transforming_done": "Aperçu prêt"
                    }
                },
                "regenerate": {
                    "title": "Générer à nouveau",
                    "feedback_placeholder": "\"Plus ressemblant\" ou \"Des couleurs plus vives\"",
                    "with_feedback": "Avec commentaire",
                    "error_generic": "Une erreur est survenue. Veuillez réessayer.",
                    "threshold_exceeded": "La limite quotidienne de génération de photos par IA a été atteinte. Veuillez réessayer demain.",
                    "style_additions_generate": "Aperçu avec {label}",
                    "style_additions_cost_notice": "Cela utilise 1 crédit IA",
                    "style_additions_title": "Choisir un ajout"
                },
                "crop": {
                    "panel_title": "Sélectionne ton visage",
                    "panel_description": "Utilise la zone de sélection pour cadrer ton visage. Cela te donnera le meilleur résultat.",
                    "image_load_error": "Nous n'avons pas pu charger ta photo. Essaie une autre image.",
                    "zoom_in": "Zoom avant",
                    "zoom_out": "Zoom arrière",
                    "validating": "Vérification photo…",
                    "error_title": "Cela n’a pas fonctionné"
                },
                "validation": {
                    "retry": "Choisir une autre photo",
                    "cancel": "Annuler",
                    "no_face": {
                        "title": "Visage non reconnu",
                        "description": "Nous n’avons pas reconnu de visage net dans votre sélection. Déplacez la sélection sur le visage ou importez une autre photo.",
                        "tip_1": "Regarde droit dans l'objectif.",
                        "tip_2": "Assure-toi d'avoir un bon éclairage — évite la contre-jour.",
                        "tip_3": "Enlève les lunettes de soleil, masques ou casquettes."
                    },
                    "no_pet": {
                        "title": "Aucun animal détecté",
                        "description": "Nous n'avons pas pu détecter un animal sur ta photo. Télécharge une photo sur laquelle ton animal est clairement visible."
                    },
                    "mismatch": {
                        "title": "Aucune personne détectée",
                        "description": "Nous n’avons pas reconnu de personne dans votre sélection. Déplacez la sélection sur le visage ou importez une autre photo.",
                        "tip_1": "Déplacez la sélection pour que le visage soit dans le cadre.",
                        "tip_2": "Ou importez une photo où la personne est bien visible."
                    },
                    "unsafe": {
                        "title": "Photo non acceptée",
                        "description": "Ta photo ne respecte pas nos directives. Télécharge une autre photo.",
                        "tip_1": "Utilise une photo de portrait neutre et appropriée."
                    },
                    "unavailable": {
                        "title": "Vérification indisponible",
                        "description": "La vérification photo est temporairement indisponible. Ta photo a été transmise telle quelle.",
                        "tip_1": "Réessaie plus tard si tu rencontres des problèmes."
                    }
                },
                "daily_limit_reached": "La génération de photos par IA est temporairement indisponible. Veuillez réessayer demain.",
                "user_daily_limit_reached": "Vous avez atteint votre limite de génération IA. Veuillez réessayer dans 1 heure. | Vous avez atteint votre limite de génération IA. Veuillez réessayer dans {count} heures.",
                "related_styles": {
                    "title": "Styles IA"
                },
                "view_previous_generations": "Voir les générations précédentes",
                "transfer": {
                    "title": "Réutiliser votre photo précédente",
                    "dismiss": "Utiliser une autre photo",
                    "generate": "Générer maintenant",
                    "photo_label": "Ta photo",
                    "change": "Changer de photo"
                },
                "beauty_shots_generating": "Encore {count} photo produit en cours de création... | Encore {count} photos produit en cours de création...",
                "personalization": {
                    "alignment_label": "Alignement",
                    "weight_label": "Graisse",
                    "reset_text": "Réinitialiser le texte",
                    "remove_text": "Supprimer le texte",
                    "remove_all_text": "Recommencer",
                    "weight_300": "Fin",
                    "weight_400": "Normal",
                    "weight_500": "Moyen",
                    "weight_600": "Semi-gras",
                    "weight_700": "Gras",
                    "weight_800": "Extra gras",
                    "weight_900": "Noir",
                    "uncommitted_modal_title": "Texte pas encore généré",
                    "uncommitted_modal_body": "Vous avez ajouté du texte, mais il n'a pas encore été généré sur la photo.",
                    "uncommitted_add_without_text": "Commander sans texte",
                    "uncommitted_generate": "Générer et vérifier",
                    "uncommitted_cancel": "Continuer la personnalisation",
                    "uncommitted_generate_and_add": "Générer & continuer",
                    "uncommitted_next_product_options": "Vous choisirez ensuite vos options de produit.",
                    "uncommitted_next_redirect_to_cart": "Vous serez ensuite redirigé vers votre panier.",
                    "active_banner": "Autres photos verrouillées",
                    "active_banner_tooltip": "Vous êtes en mode personnalisation. Réduisez la personnalisation pour revoir les autres photos, ou générez un aperçu.",
                    "remove": "Supprimer le texte",
                    "drag_hint": "Faites glisser pour déplacer",
                    "update_preview": "Enregistrer et prévisualiser",
                    "add_text": "Ajouter du texte",
                    "generating": "Génération...",
                    "committed_hint": "Supprimez un texte pour revenir à l'aperçu d'origine.",
                    "background_padding_label": "Opvulling",
                    "color_label": "Couleur du texte",
                    "font_label": "Police",
                    "mode_text": "Texte",
                    "preview_mode": "Mode aperçu – pas encore généré",
                    "size_label": "Taille",
                    "text_placeholder": "Votre texte ici",
                    "title": "Ajouter du texte",
                    "title_update": "Mettre à jour la personnalisation",
                    "field_label": "Nom/texte",
                    "cta_add": "Ajouter",
                    "cta_edit": "Modifier",
                    "edit_baked_text": "Modifier le texte",
                    "edit_baked_notice": "Votre texte fait maintenant partie de l’image. Si vous le modifiez, nous recréons les photos avec votre nouveau texte.",
                    "view_photos": "Voir toutes les photos",
                    "mobile_save": "Enregistrer",
                    "text_done": "Enregistrer le texte"
                },
                "cycle_limit_go_back": "← Voir les résultats précédents",
                "cycle_limit_reached_with_previous_title": "Vous avez utilisé toutes vos tentatives",
                "user_limit_reached_unknown_wait": "Vous avez atteint votre limite de génération IA. Veuillez réessayer plus tard.",
                "status": {
                    "loading": {
                        "label": "Votre photo est en cours d’envoi",
                        "description": "Nous vous emmenons ensuite automatiquement à l’étape suivante."
                    },
                    "offline": {
                        "title": "Pas de connexion",
                        "description": "Vous êtes hors ligne. Nous reprendrons dès que votre connexion sera rétablie."
                    },
                    "errors": {
                        "title": "Échec de l'envoi",
                        "generic": "Une erreur est survenue pendant l'envoi. Veuillez réessayer.",
                        "retry_cta": "Réessayer"
                    }
                }
            }
        },
        "product_options": {
            "preview_alt": "Aperçu",
            "saved_price": "Vous économisez {amount}",
            "title": "Aperçu de votre produit",
            "preview_loading": "Chargement de l'aperçu...",
            "update_cart": "Mettre à jour le panier"
        },
        "tools": {
            "add_to_cart_error": {
                "description": "Nous n'avons pas pu ajouter votre produit au panier. Ne vous inquiétez pas — votre configuration est enregistrée.",
                "retry": "Réessayer",
                "title": "Une erreur est survenue"
            },
            "ai": {
                "crop": {
                    "title": "Recadrer",
                    "sidebar": "Outils de recadrage"
                },
                "select": {
                    "title": "Choisir",
                    "heading": "Choisis ta préférée",
                    "description": "Choisis la version que tu préfères.",
                    "candidate_label": "Version {number}",
                    "name_placeholder": "Ton nom",
                    "candidate_pending": "Cette version est en cours de création…",
                    "candidate_failed": "Cette version n'a pas pu être créée.",
                    "candidate_retry": "Réessayer",
                    "candidate_selected": "Sélectionnée",
                    "select_candidate": "Choisir la version {number}",
                    "view_larger": "Voir la version {number} en grand",
                    "choose_this": "Choisir celle-ci",
                    "show_all": "Afficher toutes mes images",
                    "limit_reached": "Tu as atteint ta limite de génération. Choisis parmi les images que tu as déjà.",
                    "regenerate_question": "Pas convaincu ?",
                    "regenerate": "Crée deux nouvelles",
                    "regenerating": "Génération de deux images supplémentaires…",
                    "regenerate_error": "Nous n'avons pas pu générer d'autres images. Réessaie plus tard.",
                    "save_error": "Nous n'avons pas pu enregistrer ton choix. Réessaie."
                },
                "configurator": {
                    "title": "Personnaliser",
                    "sidebar": "Texte",
                    "panel_title": "Ajoutez votre texte",
                    "name_required_hint": "Saisissez votre propre prénom pour continuer.",
                    "view_preview_button": "Voir l'aperçu",
                    "preparing": {
                        "loading": {
                            "label": "Nous créons votre image produit",
                            "description": "Un instant…"
                        }
                    }
                },
                "preview": {
                    "title": "Aperçu",
                    "shot_pending": "Cette image est en cours de création…",
                    "shot_failed": "Cette image n'a pas pu être créée.",
                    "retry_shot": "Réessayer",
                    "go_to_shot": "Aller à l'image {number}",
                    "previous_shot": "Image précédente",
                    "next_shot": "Image suivante",
                    "view_larger": "Voir l'image {number} en grand",
                    "filling": "Création des images"
                }
            },
            "mediaclip": {
                "configurator": {
                    "choose_size": {
                        "label": "Choisissez votre taille"
                    },
                    "custom_size": {
                        "label": "Choisir une taille personnalisée"
                    },
                    "title": "Configurateur"
                }
            },
            "product_options": {
                "title": "Options du produit"
            }
        },
        "success_page": {
            "banner": {
                "title": "Commandé !",
                "sub_title": "Merci pour votre commande. Nous allons nous y mettre immédiatement."
            },
            "title": "Et maintenant ?",
            "steps": {
                "order_confirmation": {
                    "title": "Confirmation de commande",
                    "description": "Nous vous envoyons une confirmation de commande (<strong>#{orderNumber}</strong>) à votre adresse e-mail. Retrouvez toutes vos commandes dans votre compte.",
                    "description_fallback": "Nous vous envoyons une confirmation de commande à votre adresse e-mail. Retrouvez toutes vos commandes dans votre compte.",
                    "summary": {
                        "total_paid": "Total payé (TVA incl.)",
                        "total_in_email": "Vous trouverez le montant payé dans votre confirmation de commande.",
                        "show": "Voir votre commande",
                        "hide": "Masquer votre commande",
                        "discount": "Réduction",
                        "discount_code": "Code promo {code}",
                        "shipping": "Frais de livraison",
                        "free": "Gratuit",
                        "payment_fee": "Frais de paiement",
                        "other": "Autre",
                        "total": "Total"
                    }
                },
                "shipping_confirmation": {
                    "title": "Confirmation d'expédition",
                    "description": "Vous recevrez un e-mail dès que vos produits seront emballés et remis au transporteur.",
                    "delivery_date": "Livraison prévue le"
                },
                "delivery_address": {
                    "title": "Adresse de livraison",
                    "description": "Vos article(s) seront livrés à",
                    "info": "Absent ? Votre colis sera déposé chez un voisin ou en point relais."
                },
                "questions": {
                    "title": "Des questions ?",
                    "description": "Nous sommes là pour vous aider ! Jetez un œil à notre",
                    "customer_service_link": "page service client",
                    "show_the_wow": {
                        "title": "Montrez le WOW !",
                        "description": "Montrez à vos amis ce que vous vous êtes offert !",
                        "instagram_label": "Instagram",
                        "facebook_label": "Facebook"
                    },
                    "news_letter": {
                        "label": "Exclusif",
                        "title": "Devenez membre WOW ?",
                        "usp_1": "10% de réduction sur votre prochaine commande",
                        "usp_2": "Découvrez les nouveaux designs et produits en avant-première",
                        "usp_3": "Codes promo & offres exclusifs",
                        "button": "Devenir membre"
                    }
                }
            },
            "page_title": "Commande passée !"
        },
        "checkout_page": {
            "form": {
                "delivery": {
                    "available_from": "Disponible à partir de",
                    "choose_pickup_location": "Choisissez votre point de prise en charge",
                    "day_after_tomorrow_delivery": "Commandez aujourd'hui, <b>après-demain</b> chez vous !",
                    "deliver_at_pickup_location": "Sélectionnez un point de prise en charge",
                    "latest_delivery": "Votre colis sera livré à votre domicile au plus tard le",
                    "no_address": "Saisissez votre adresse de livraison pour consulter les modes de livraison disponibles.",
                    "no_pickup_locations": "Aucun point de retrait trouvé",
                    "opening_times": {
                        "label": "Horaires d'ouverture"
                    },
                    "postal_code_search": {
                        "button": "Rechercher",
                        "label": "Code postal",
                        "placeholder": "Entrez un code postal"
                    },
                    "selected_pickup_location": "Point de prise en charge sélectionné :",
                    "show_on_map": "Afficher sur la carte",
                    "show_other_pickup_locations": "Afficher plus de points de retrait",
                    "tabs": {
                        "delivery": "Livraison",
                        "pickup": "Point de ramassage"
                    },
                    "tomorrow_delivery": "Commandez aujourd'hui, <b>demain</b> chez vous !",
                    "error": "Une erreur s'est produite lors du chargement des options de livraison."
                },
                "payment": {
                    "no_address": "Saisissez votre adresse de livraison pour consulter les modes de paiement disponibles.",
                    "no_payment_required": "Aucun paiement requis.",
                    "no_payment_required_subtitle": "Votre commande est entièrement couverte par votre code promo."
                }
            },
            "free": "Gratuit",
            "messages": {
                "errors": {
                    "billing_address_missing": "Votre adresse de facturation est incomplète. Veuillez vérifier votre adresse et réessayer.",
                    "placing_order_failed": "Votre commande ne peut être passée pour le moment.",
                    "shipping_address_missing": "Votre adresse de livraison est incomplète. Veuillez vérifier votre adresse et réessayer."
                }
            },
            "overview": {
                "place_order_button": {
                    "label": "Passer la commande"
                },
                "prices": {
                    "discount": "Remise",
                    "shipping_costs": "Frais d'expédition",
                    "shipping_surcharge": "Supplément",
                    "payment_fee": "Frais de paiement",
                    "subtotal": "Total",
                    "total": "Total",
                    "you_save": "Vous économisez",
                    "coupon_code": "Code promo",
                    "incl_vat": "dont {amount} de TVA",
                    "promotion_discount": "Remise promotionnelle"
                },
                "quote_items": {
                    "count": "1 article | {count} articles",
                    "quantity": "Quantité : {quantity}"
                },
                "title": "Aperçu"
            },
            "payment": {
                "most_popular": "Le plus choisi"
            }
        },
        "configurator": {
            "sizes": {
                "most_chosen": "Le plus choisi"
            }
        },
        "search": {
            "title": "Résultats de recherche",
            "title_with_query": "Résultats de recherche pour ‘{query}’",
            "products_title": "Produits",
            "heading_all": "Tous les designs",
            "heading_with_query": "Résultats de recherche pour ‘{query}’",
            "heading_no_results": "Aucun résultat pour ‘{query}’",
            "subtitle_no_results": "Vérifiez l'orthographe ou essayez un terme plus général.",
            "browse_by_product_title": "Parcourir par produit"
        }
    },
    "slices": {
        "algolia_slider": {
            "price": {
                "else": "sinon",
                "from": "à partir de"
            }
        },
        "plp_before_after": {
            "before": "Avant",
            "after": "Après"
        },
        "plp_customer_images": {
            "image_alt": "Photo client"
        },
        "pdp_before_after": {
            "before": "Avant",
            "after": "Après"
        },
        "contact_form_business": {
            "gift_timing_placeholder": "Quand voulez-vous offrir les valises en cadeau ?*",
            "referral_placeholder": "Comment avez-vous entendu parler de nous ?*",
            "no_options": "Aucune option disponible",
            "selected_file": "Fichier sélectionné :",
            "required_fields": "Veuillez remplir tous les champs obligatoires.",
            "submit_error": "Une erreur s'est produite lors de l'envoi du formulaire. Veuillez réessayer.",
            "invalid_file_type": "Type de fichier non valide. Seuls les formats JPEG, PNG, GIF, BMP, WEBP ou SVG sont autorisés."
        },
        "banner_slider": {
            "excellent": "Excellent"
        }
    },
    "tools": {
        "mediaclip": {
            "configurator": {
                "designer": {
                    "loading": "Nous préparons le configurateur."
                },
                "footer": {
                    "buttons": {
                        "cancel": {
                            "label": "Annuler"
                        },
                        "change_size": {
                            "label": "Modifier le format ({size})"
                        },
                        "choose_size": {
                            "label": "Choisissez votre taille"
                        },
                        "to_photo": {
                            "label": "Vers la photo {number}"
                        }
                    }
                },
                "hexagon_photos_required_modal": {
                    "title": "Photos manquantes",
                    "description": "Les photos {list} ne sont pas encore remplies. Appuie sur un cadre vide, ajoute ta photo et réessaie.",
                    "letter_collage_description": "Tous les cadres n'ont pas encore de photo. Appuie sur un cadre vide, ajoute ta photo et réessaie.",
                    "close": "Compris"
                },
                "connection_lost_modal": {
                    "title": "Connexion perdue",
                    "description": "Nous ne parvenons pas à accéder à ton design pour le moment. Vérifie ta connexion internet et recharge la page ; ton design est enregistré automatiquement.",
                    "reload": "Recharger la page"
                },
                "project_title": {
                    "error": "Échec de l'enregistrement",
                    "label": "Titre du projet",
                    "placeholder": "Saisissez un titre...",
                    "saved": "Enregistré",
                    "saving": "Enregistrement..."
                }
            }
        },
        "landscape_popup": {
            "text": "Cette page fonctionne mieux si vous tournez l'écran. Veuillez tourner l'écran pour continuer votre commande."
        }
    },
    "checkout": {
        "billing_address": {
            "title": "Adresse de facturation"
        },
        "delivery": {
            "preferences": {
                "label": "Quelle livraison préférez-vous ?",
                "express": {
                    "description": "Commandez aujourd'hui, livré après-demain !",
                    "label": "Livraison express"
                },
                "regular": {
                    "label": "Livraison standard"
                }
            },
            "title": "Livraison",
            "delivery_date_info": "Votre commande sera livrée au plus tard le ",
            "info": "Saisissez vos informations de livraison pour voir les options disponibles"
        },
        "form": {
            "address_finder": {
                "invalid_address": "L'adresse saisie est introuvable. Veuillez vérifier vos informations et réessayer.",
                "label": "Recherche d'adresse",
                "placeholder": "Commencez à saisir pour rechercher votre adresse",
                "address_filled": "Votre adresse a été remplie.",
                "select_address": "Veuillez sélectionner votre adresse dans la liste."
            },
            "city": {
                "label": "Ville",
                "placeholder": "Ville",
                "invalid_characters": "Utilisez uniquement des lettres, des espaces, des traits d'union (-) et des apostrophes ('), 100 caractères maximum."
            },
            "company": {
                "label": "Nom de l'entreprise",
                "placeholder": "Nom de l'entreprise"
            },
            "country": {
                "label": "Pays"
            },
            "email": {
                "label": "Adresse e-mail",
                "placeholder": "Adresse e-mail",
                "label_track_trace": "Adresse e-mail pour le suivi du colis"
            },
            "first_name": {
                "label": "Prénom",
                "placeholder": "Prénom"
            },
            "house_number": {
                "label": "Numéro",
                "placeholder": "p. ex. 1"
            },
            "house_number_suffix": {
                "label": "Complément",
                "placeholder": "p. ex. A"
            },
            "order_type": {
                "corporate": {
                    "label": "Entreprise"
                },
                "private": {
                    "label": "Particulier"
                },
                "title": "Type de commande"
            },
            "phone_number": {
                "label": "Numéro de téléphone",
                "placeholder": "Numéro de téléphone",
                "invalid_characters": "Utilisez uniquement des chiffres, des espaces et + - ( ), 20 caractères maximum."
            },
            "same_address": {
                "label": "Les adresses de facturation et de livraison sont identiques"
            },
            "street_name": {
                "label": "Nom de rue",
                "placeholder": "Nom de rue"
            },
            "surname": {
                "label": "Nom",
                "placeholder": "Nom"
            },
            "vat_number": {
                "label": "Numéro de TVA",
                "placeholder": "Numéro de TVA"
            },
            "zipcode": {
                "label": "Code postal",
                "placeholder_example": "p. ex. {example}",
                "invalid": "Saisissez un code postal valide, p. ex. {example}."
            },
            "save_in_address_book": {
                "label": "Enregistrer dans le carnet d'adresses"
            },
            "newsletter_subscribe": {
                "label": "Tenez-moi informé(e) des actualités, inspirations et offres exclusives par e-mail"
            },
            "account_type": {
                "title": "Compte",
                "guest": {
                    "label": "Continuer en tant qu'invité"
                },
                "create": {
                    "label": "Créer un compte"
                },
                "email_taken": "Un compte existe déjà avec cette adresse e-mail.",
                "login_link": "Se connecter",
                "password_required": "Saisis deux fois le même mot de passe pour créer ton compte.",
                "privacy_required": "Tu dois accepter la politique de confidentialité pour créer ton compte."
            }
        },
        "payment": {
            "title": "Paiement",
            "ideal_wero": {
                "description": "iDEAL {'|'} Wero"
            },
            "paypal": {
                "description": "Paypal"
            }
        },
        "shipping_address": {
            "title": "Adresse de livraison"
        },
        "customer_addresses": {
            "add_new": "Ajouter une nouvelle adresse",
            "create_modal_title": "Nouvelle adresse",
            "edit_modal_title": "Modifier l'adresse",
            "delete_modal_title": "Supprimer l'adresse"
        },
        "address_book": {
            "add_new": "Ajouter une nouvelle adresse",
            "default_billing": "Adresse de facturation par défaut",
            "default_shipping": "Adresse de livraison par défaut",
            "create_modal": {
                "title_shipping": "Nouvelle adresse de livraison",
                "title_billing": "Nouvelle adresse de facturation",
                "confirm": "Enregistrer",
                "cancel": "Annuler"
            },
            "edit_modal": {
                "title": "Modifier l'adresse",
                "confirm": "Enregistrer",
                "cancel": "Annuler"
            },
            "delete_modal": {
                "title": "Supprimer l'adresse",
                "confirm": "Supprimer",
                "cancel": "Annuler",
                "description": "Êtes-vous sûr de vouloir supprimer cette adresse ? Cette action ne peut pas être annulée."
            },
            "save_failed": "L'enregistrement a échoué. Veuillez réessayer.",
            "delete_failed": "La suppression a échoué. Veuillez réessayer.",
            "order_only": "Uniquement pour cette commande"
        }
    }
}
